<div class="ticket-sheet">
  <header class="sheet-head">
    <div class="name-line">
      <h2 class="product-name">{{ product.name }}</h2>
      @if (onViewInfo) {
      <button type="button" class="view-info" (click)="onViewInfo()">
        <ion-icon name="information-circle-outline" aria-hidden="true" />
        {{ "generate-ticket-modal.view-info" | translate }}
      </button>
      }
    </div>
    <div class="price-line">
      <span class="unit-price">
        @if (hasPrice) {
        {{ "generate-ticket-modal.unit-price" | translate: { price: (unitPrice | arsCurrency) } }}
        } @else {
        {{ "top-products.noCharge" | translate }}
        }
      </span>
      <span class="status-chip" [class.is-unpaid]="product.pay_at_door">
        <ion-icon [name]="product.pay_at_door ? 'time-outline' : 'checkmark-outline'" aria-hidden="true" />
        {{ (product.pay_at_door ? "generate-ticket-modal.unpaid-badge" : "generate-ticket-modal.paid-badge") | translate }}
      </span>
    </div>
  </header>

  <app-input-form
    [control]="referenceControl"
    label="generate-ticket-modal.reference-label"
    type="text"
    placeholder="generate-ticket-modal.reference-placeholder"
    [showBorder]="true"
  />

  <app-quantity-selector
    [value]="quantity()"
    (valueChange)="quantity.set($event)"
    [min]="1"
    [max]="productLimit"
    [label]="'generate-ticket-modal.quantity-label' | translate"
  />

  <app-info-alert
    [message]="(product.pay_at_door ? 'generate-ticket-modal.alert-pay-at-door' : 'generate-ticket-modal.alert-own-collection') | translate"
    type="info"
  />

  @if (hasPrice) {
  <div class="total-row">
    <span>{{ (product.pay_at_door ? "generate-ticket-modal.total-door" : "generate-ticket-modal.total-own") | translate }}</span>
    <strong class="total-amount">{{ total | arsCurrency }}</strong>
  </div>
  }

  <app-main-button
    [label]="'generate-ticket-modal.confirm'"
    [loadingLabel]="'generate-ticket-modal.generating'"
    [loading]="isGenerating()"
    [disabled]="isGenerating()"
    (clicked)="onSubmitGenerateTicket()"
  />
</div>
